import { initLogin } from "./services/authService";
import { useEffect, useState } from "react";
import Login from "./components/Login/Login";
import { BrowserRouter, Route, Routes as AppRoutes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import Layout from "./components/Layout";
import { Routes } from "./config/Routes";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css"
import Home from "./components/Home/Home";
import UsersView from "./components/Users/UsersView";




function App() {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            initLogin().finally(() => setLoading(false));
        };
        init();
    }, []);


    const theme = createTheme({
        palette: {
            background: {
                default: "#E5E5E5",
            },
            primary: {
                main: "#ED6E11",
            },
            secondary: {
                main: "#BF549A",
            },
        },
    });
    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <Layout>

                    <AppRoutes>
                        <Route
                            path={Routes.Home}
                            element={<ProtectedRoute element={<Home />}></ProtectedRoute>}
                        ></Route>

                        <Route
                            path={Routes.Users}
                            element={<ProtectedRoute element={<UsersView />}></ProtectedRoute>}
                        ></Route>
                        

                        <Route path={Routes.Login} element={<Login />}></Route>
                    </AppRoutes>
                </Layout>
            </ThemeProvider>
        </BrowserRouter>
    );
}



export default App;
